import { useEffect, useRef, useState } from "react";

const getCurrentDimensions = (ref) => {
  if (ref.current) {
    const { current } = ref;
    return {
      width: Math.round(current.clientWidth),
      height: Math.round(current.clientHeight),
    };
  }
  return { width: 0, height: 0 };
};

export default function ActivityResizable({ children, color, onResize }) {
  const divRef = useRef(null);
  const [dim, setDim] = useState({ width: 0, height: 0 });

  useEffect(() => {
    setDim(getCurrentDimensions(divRef));
  }, [divRef]);

  return (
    <div
      ref={divRef}
      onMouseUp={() => {
        const newDim = getCurrentDimensions(divRef);
        onResize({
          ...dim,
          newHeight: newDim.height,
          newWidth: newDim.width,
        });
      }}
      className={`group absolute inset-0 w-full h-full hover:resize-y flex flex-col overflow-hidden rounded-lg border border-gray-200 bg-${color}-50 hover:bg-${color}-100 px-2 text-xs leading-5`}
    >
      {children}
    </div>
  );
}
